<template>
	<div>
		<b-modal
			v-model="locktestModal"
			id="locktest"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="m"
			@hide="$emit('hide')"
		>
			<div class="modalheading">
				<span>Confirmation</span>
			</div>
			<div @click="closetestmodal" class="xMarkCancel pointer">
				<img src="../../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div>
				<div class="lock-text-head mt-3 wordbreak">
					Do you want to {{ lockButtonText }}
					<strong>“{{ clone.name }}”</strong> test ?
				</div>
				<div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<div
							@click="closetestmodal"
							style="width: 15%"
							class="d-flex align-items-center mr-2 pointer cancel-lock"
						>
							<span class="cancel-lock-text ml-2">Cancel</span>
						</div>

						<b-button
							class="addbtn mr-3"
							style="border-radius: 5px; width: 20%"
							@click="LockTest"
						>
							{{ clone.isLocked ? "Unlock" : "Lock" }}
						</b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import { putTest } from "../../../utils/apiFunctions";
export default {
	name: "TestLock",
	data() {
		return {
			clone: { ...this.testDetails },
		};
	},
	props: {
		locktestModal: Boolean,
		testDetails: Object,
		topicID: String,
		context: Object,
	},
	created() {
		// Add a global event listener for keyup
		window.addEventListener("keyup", this.handleKeyUp);
	},

	beforeDestroy() {
		// Lifecycle hook: Component is about to be destroyed
		// Remove the global event listener when the component is destroyed
		window.removeEventListener("keyup", this.handleKeyUp);
	},
	computed: {
		lockButtonText() {
			return this.clone.isLocked ? "unlock" : "lock";
		},
	},

	methods: {
		async LockTest() {
			try {
				let payload = {
					topicID: this.topicID,
					testID: this.clone.testID,
					name: this.clone.name,
					publicAvailability: this.clone.publicAvailability,
					isLocked: !this.clone.isLocked,
				};
				const response = await putTest({ ...payload });
				if (response.status === 200) {
					this.$emit("resetPagination");
					setTimeout(() => {
						if (payload.isLocked) {
							this.context.successToast("Test locked successfully!");
						} else {
							this.context.successToast("Test unlocked successfully!");
						}
					}, 200);
					this.$bvModal.hide("locktest");
				}
			} catch (error) {
				console.log(error);
			}
		},

		closetestmodal() {
			this.$bvModal.hide("locktest");
		},
		// Event handler for keyup event
		handleKeyUp(event) {
			if (event.keyCode === 13) {
				// If Enter key is pressed, call deleteTest method
				this.LockTest();
			}
		},
	},
};
</script>
<style scoped>
.cancel-lock {
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px;
}

.cancel-lock-text {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}
.lock-text-head {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	line-height: 21px;
	color: #545454;
}
</style>
